import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

function fmtDate(iso) {
  try {
    return new Date(iso).toLocaleString("en-US", {
      month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "2-digit",
    });
  } catch { return iso || ""; }
}

export default function AdminContacts() {
  const [items, setItems] = useState([]);
  const [err, setErr] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await axios.get(`${API}/admin/contacts`, { withCredentials: true });
        setItems(res.data.items || []);
      } catch (e) { setErr(e?.response?.data?.detail || "Failed to load"); }
      finally { setLoading(false); }
    })();
  }, []);

  return (
    <section data-testid="admin-contacts">
      <h2 className="font-serif text-3xl md:text-4xl font-light mb-8 tracking-tight">
        Contact messages
      </h2>
      {err && <p className="text-red-600 text-sm mb-4">{err}</p>}
      {loading ? (
        <p className="text-[#0F1F4E]/70">Loading…</p>
      ) : items.length === 0 ? (
        <p className="text-[#0F1F4E]/70">No messages yet.</p>
      ) : (
        <ul className="space-y-4">
          {items.map((it) => (
            <li
              key={it.id}
              data-testid={`contact-row-${it.id}`}
              className="bg-white border border-[#D9CFA0] rounded-lg p-5"
            >
              <div className="flex flex-wrap items-baseline justify-between gap-3 mb-2">
                <div>
                  <div className="font-serif text-xl">{it.name}</div>
                  <a href={`mailto:${it.email}`} className="text-sm underline text-[#0F1F4E]/80">{it.email}</a>
                  <span className="text-sm text-[#0F1F4E]/60"> · </span>
                  <a href={`tel:${it.phone}`} className="text-sm text-[#0F1F4E]/70">{it.phone}</a>
                </div>
                <span className="text-xs uppercase tracking-wider text-[#0F1F4E]/60">{fmtDate(it.created_at)}</span>
              </div>
              <p className="text-sm leading-relaxed whitespace-pre-wrap">{it.message}</p>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
